import React from 'react';
import { DEFAULT_HIGHLIGHT_COLOR, MIN_COLS, MAX_COLS, COLS_TO_SKIP, INIT_COL_CLASS } from '../consts';
import { cn, getColorway, getCustomBackgroundColor } from 'utils/styles';
import { Node } from '@contentful/rich-text-types';
import type { Color } from 'libs/contentful/types';
import { TableChild } from '../types';

export const renderTableRow = (
  _node: Node,
  children: React.ReactNode,
  highlightedColumnIndex: number,
  highlightColor: Color | undefined,
  sectionColorway: string,
) => {
  const tableChildren = React.Children.toArray(children) as TableChild[];
  const cells = tableChildren.filter(c => c.type === 'td' || c.type === 'th');
  const cellCount = cells.length;
  const lessThanMax = cellCount < MAX_COLS;
  const isMin = cellCount == MIN_COLS;
  const className = cn(lessThanMax ? 'first-col-50' : 'first-col-33', isMin && 'last-col-hidden');

  const highlightColorwayClass = getColorway(highlightColor ?? DEFAULT_HIGHLIGHT_COLOR);
  const customBg = highlightColor && getCustomBackgroundColor(highlightColor);

  return (
    <tr className={className}>
      {tableChildren.map((child, i) => {
        if (child.type === 'td' || child.type === 'th') {
          const isHighlighted = i === highlightedColumnIndex;

          return React.cloneElement(child, {
            'data-column': i,
            ...(isHighlighted && { 'data-highlighted': 'true' }),
            className: cn(
              i > COLS_TO_SKIP ? 'col-hidden' : isHighlighted && INIT_COL_CLASS,
              'rtt-cell',
              isHighlighted ? !customBg && highlightColorwayClass : i > 0 && sectionColorway,
            ),
          });
        }
        return child;
      })}
      {isMin && <td aria-hidden className="rtt-cell"></td>}
    </tr>
  );
};
